import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import getters from './getters'
import permission from './modules/permission'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    common,
    permission
  },
  getters
})

export default store
